import { getUsersFeatureFlags } from '../api/featureFlags'

import { getUserProfile } from './auth'

const STORAGE_KEY = 'phi_migration_phase'
const DEFAULT_PHI_MIGRATION_PHASE = 'NONE'
let inMemory: string | null = null

export const setPhiPhase = (phase: string) => {
  inMemory = phase
  localStorage.setItem(STORAGE_KEY, phase)
}

export const getPhiPhase = (): string => {
  if (inMemory) return inMemory
  const stored = localStorage.getItem(STORAGE_KEY)

  return stored ?? DEFAULT_PHI_MIGRATION_PHASE
}

export const clearPhiPhase = () => {
  inMemory = null
  localStorage.removeItem(STORAGE_KEY)
}

export const loadPhiPhase = async (): Promise<string> => {
  const profile = getUserProfile()
  const username = profile?.user_name ?? profile?.sub

  if (!username) {
    setPhiPhase(DEFAULT_PHI_MIGRATION_PHASE)
    return DEFAULT_PHI_MIGRATION_PHASE
  }

  try {
    const flags = await getUsersFeatureFlags(username, 'web')
    const migrations = flags?.['Migrations']
    const value =
      migrations && typeof migrations === 'object'
        ? (migrations as Record<string, unknown>)['phi-migration-phase']
        : null
    const phase = typeof value === 'string' ? value : DEFAULT_PHI_MIGRATION_PHASE

    setPhiPhase(phase)
    return phase
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    setPhiPhase(DEFAULT_PHI_MIGRATION_PHASE)
    return DEFAULT_PHI_MIGRATION_PHASE
  }
}
